import React from "react";
import Flex from "@/components/layout/Flex";
import Link from "@/components/ui/Link";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import Button from "../Root";
import type { LinkButtonProps } from "./types";

function ButtonLink({
  "aria-label": ariaLabel,
  className,
  ...props
}: LinkButtonProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Flex.Row
      asChild
      justify="center"
      items="center"
      gap="gap-2"
      className="w-fit"
    >
      <Button
        as={Link}
        className={cn(className, classes)}
        aria-label={ariaLabel}
        {...native}
      />
    </Flex.Row>
  );
}

export default ButtonLink;
